<template>
    <input :value="value"/>
</template>

<script>
import ionRangeSlider from 'ion-rangeslider'
import $ from 'jquery'

export default {
    name: "IonSlider",
    props: ['options', 'value'],

    mounted: function () {
        let vm = this
        $(this.$el)
            .ionRangeSlider(this.options)
            // emit event on change.
            .on('change', function () {
                vm.$emit('input', this.value)
            })
        this.$slider = $(this.$el).data('ionRangeSlider')
    },
    watch: {
        options: function (value) {
            this.$slider.update(value)
        }
    },
    destroyed: function () {
        this.$slider.destroy()
    }
}
</script>

<style scoped>

</style>
